module.exports = __webpack_public_path__ + "static/specialists-slideshow-02-7d6e037dab531707c2996c3c539aa1c9.jpg";